function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { constants } from '../constants';
var messages = {
    NETWORK_ERROR: constants.api_error_network_error,
    TIMEOUT: constants.api_error_timeout,
    CORS_ERROR: constants.api_error_cors_error,
    UNAUTHORIZED: constants.api_error_unauthorized,
    FORBIDDEN: constants.api_error_forbidden,
    NOT_FOUND: constants.api_error_not_found,
    BAD_REQUEST: constants.api_error_bad_request,
    RATE_LIMITED: constants.api_error_rate_limited,
    SERVER_ERROR: constants.api_error_server_error,
    NAME_DUPLICATION: constants.api_error_name_duplication,
    MANDATORY_FIELDS_MISSING: constants.api_error_mandatory_fields_missing,
    SERVICE_UNAVAILABLE: constants.api_error_service_unavailable
};
export var apiError = Object.fromEntries(Object.entries(messages).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2), k = _ref2[0], v = _ref2[1];
    return [k, {
            key: k,
            message: v
        }];
}));
